module.exports = __webpack_public_path__ + "assets/img/A2.a8c5127e.png";